import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';
import { Stack } from '@mui/material';

export const config: FormDialogConfig = {
  title: (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Icon name="location" size={20} color="primary.400" />
      Edit Billing Information
    </Stack>
  ),
  icon: false,
  submitButtonProps: {
    children: 'Save',
    variant: 'contained',
    size: 'small',
    color: 'primary',
  },
};

export const scheme = yup.object().shape({
  name: yup.string().required('Company name is required.'),
  address: yup.object().shape({
    line1: yup.string().required('Address is required.'),
    postalCode: yup.string().required('Postal code is required.'),
    city: yup.string().required('City is required.'),
    country: yup.string().required('Country is required.'),
  }),
  taxIds: yup.array().of(
    yup.object().shape({
      type: yup.string().required('Tax ID type is required.'),
      value: yup.string().required('Tax ID value is required.'),
      existing: yup.boolean().notRequired(),
    })
  ),
});
